export default __webpack_public_path__ + "static/media/logo_dashboard.b84d1b0d.png";